import React, { useState } from 'react';
import styled from 'styled-components';
import { components } from 'react-select';

import * as api from '~services/api';

import { useToast } from '~features/toast';

import {
  TagField,
  TextField,
  TextareaField,
  CheckboxField,
  PhoneField,
  SelectField,
  DropzoneField,
  EmailField,
  OfficeField,
  ParagraphField,
} from '~fields';
import { Gap, FormLabel as Label, Columns } from '~ui-kit';

import Device from './Device';

const formatDevice = device => ({
  value: device.deviceId,
  label: `${device.deviceId} (${device.deviceType})`,
});

const getAppliances = id => {
  // If we are editing an existing order fetch appliances
  // based on initial identificationNumber of the device
  // const { customInitialValues } = this.props;
  // const deviceId = customInitialValues
  //   ? customInitialValues.identificationNumber
  //   : id;

  // Start search after user has typed 3 chars
  if (!id || id.length < 3) {
    return Promise.resolve([]);
  }

  return api
    .get(`data/maintenance/devices/search/?deviceid=${id}`)
    .then(appliances => (appliances || []).map(formatDevice));
};

// eslint-disable-next-line react/display-name
const noOptionsMessage = label => props =>
  (
    <components.NoOptionsMessage {...props}>
      {label || 'Ei hakutuloksia'}
    </components.NoOptionsMessage>
  );

const Inner = ({ values }) => {
  const [device, setDevice] = useState();
  const toast = useToast();

  const handleDeviceSelect = async option => {
    if (!option) {
      setDevice(null);
      return;
    }

    try {
      const res = await api.get(`data/maintenance/devices/${option.value}`);
      setDevice(res);
    } catch (e) {
      console.error('Error when fetching device due to device ID change', e);
      toast.error('Laitteen haku epäonnistui');
    }
  };

  switch (values.type) {
    case 'HÄIRIÖ':
      return (
        <>
          <TextField name="topic" fullWidth required />
          <Gap />
          <TextareaField name="problemDescription" required />
          <Gap />

          <LocationContainer>
            <OfficeField
              name="officeOfIncident"
              flat
              required
              labelWidth="90px"
            />
            <Gap height="16px" />
            <TextField name="placeOfIncident" required />
          </LocationContainer>

          <Columns>
            <div>
              <Label>Ilmoituksen yhteyshenkilö</Label>
              <CheckboxField name="customerIsNotNotifier" />
            </div>
            {!!values.customerIsNotNotifier && (
              <EmailField name="contactEmail" required />
            )}
          </Columns>

          <Gap />

          <Columns gap="0">
            <PhoneField name="contactPhone" required />
            <div />
          </Columns>

          <Gap />

          <Columns>
            <SelectField
              name="identificationNumber"
              fallbackLabel="Laitteen tunnusnumero"
              fallbackPlaceholder="Kirjoita esim. 01006103"
              loadOptions={getAppliances}
              async
              searchPromptText="Kirjoita vähintään kolme ensimmäistä numeroa"
              isClearable
              onChange={handleDeviceSelect}
              components={{
                NoOptionsMessage: noOptionsMessage(
                  'Hakutermiä vastaavia laitteita ei löytynyt'
                ),
              }}
            />
            <div>
              <Label>Häiriön toistuvuus</Label>
              <CheckboxField name="problemIsRepeatingWithAll" />
            </div>
          </Columns>
          <Gap />

          {!!device && <Device device={device} />}

          <DropzoneField name="attachmentInput" width="100%" />
        </>
      );
    case 'PALVELUPYYNTÖ':
      return (
        <>
          <TextField name="topic" fullWidth required />
          <Gap />
          <TextareaField name="additionalInfo" required />
          <Gap />

          <LocationContainer>
            <OfficeField
              name="officeOfIncident"
              flat
              required
              labelWidth="90px"
            />
            <Gap height="16px" />
            <TextField name="placeOfIncident" required />
          </LocationContainer>

          <Columns>
            <div>
              <Label>Ilmoituksen yhteyshenkilö</Label>
              <CheckboxField name="customerIsNotNotifier" />
            </div>
            {!!values.customerIsNotNotifier && (
              <EmailField name="contactEmail" required />
            )}
          </Columns>

          <Gap />

          <Columns>
            <PhoneField name="contactPhone" required />
            <div />
          </Columns>
          <Gap />

          <SelectField
            name="identificationNumber"
            fallbackLabel="Laitteen tunnusnumero"
            fallbackPlaceholder="Kirjoita esim. 01006103"
            loadOptions={getAppliances}
            async
            searchPromptText="Kirjoita vähintään kolme ensimmäistä numeroa"
            isClearable
            onChange={handleDeviceSelect}
            components={{
              NoOptionsMessage: noOptionsMessage(
                'Hakutermiä vastaavia laitteita ei löytynyt'
              ),
            }}
          />
          <Gap />
          {!!device && <Device device={device} />}

          <DropzoneField name="attachmentInput" width="100%" />
        </>
      );
    default:
      return null;
  }
};

const GenericSupportForm = props => {
  const {
    formik: { values },
  } = props;

  return (
    <>
      <ParagraphField name="infoParagraph" />
      <TagField name="type" required />
      <Gap />
      <Inner values={values} />
    </>
  );
};

const LocationContainer = styled.div`
  background-color: #f2f2f2;
  padding: 16px;
  margin-bottom: 40px;
  border-radius: 4px;
`;

export default GenericSupportForm;
